<template>
  <div class="form-reset-password">
    <ErrorBlock class="form-reset-password-block error" v-if="error">{{error}}</ErrorBlock>
    <BaseInput class="form-reset-password-block input" v-model.trim="input.phone" :placeholder="lang.phone"></BaseInput>
    <div class="form-reset-password-block input-code">
      <BaseInput class="code" v-model.trim="input.code" :placeholder="lang.code"></BaseInput>
      <SendVerifyCodeButton class="get-code" :phone="input.phone" :reason="2" @updateError="updateError" @updateCode="updateCode"></SendVerifyCodeButton>
    </div>
    <BaseInput class="form-reset-password-block input password" type="password" v-model.trim="input.password" :placeholder="lang.password"></BaseInput>
    <div class="form-reset-password-block tip signin" @click="signin">
      <span>已有Dartcome帐号？</span><span class="link">返回登录</span>
    </div>
    <BaseButton1 class="form-reset-password-block input" @click="commit">{{lang.commit}}</BaseButton1>
  </div>
</template>

<script>
import _ from 'lodash'

import {
  BaseButton1,
  SendVerifyCodeButton
} from '../button'
import { BaseInput } from '../input'
import { ErrorBlock } from '../block'
export default {
  components: {
    BaseButton1,
    SendVerifyCodeButton,
    BaseInput,
    ErrorBlock
  },
  props: {
    lang: {
      type: Object,
      default () {
        return {
          title: '忘记密码',
          phone: '输入手机号',
          code: '输入验证码',
          password: '输入新的密码',
          commit: '确定'
        }
      }
    },
    error: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      input: {
        phone: '',
        code: '',
        password: ''
      }
    }
  },
  methods: {
    close () { this.$emit('close') },
    commit () { this.$emit('commit', this.input) },
    signin () { this.$emit('signin') },
    updateError (e) { this.$emit('update:error', _.get(e, 'response.data.msg', e.message)) },
    updateCode (code) { this.input.code = code }
  },
  watch: {
    'input.phone' (newV, oldV) {
      if (newV === oldV) {
        return
      }
      this.$emit('update:error', null)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.form-reset-password {
  text-align: center;
  & .form-reset-password-block {
    display: inline-block;
    @media (--mediaPc) {
      width: 340px;
    }
    @media (--mediaMobile) {
      padding: calc(10px / var(--scaleMobile)) 0;
      width: calc(640px / var(--scaleMobile));
    }
    &.error {
      margin: 5px 0;
    }
    &.input {
      padding: 5px 0;
      text-align: center;
    }
    &.input-code {
      & .code {
        @media (--mediaPc) {
          width: 230px;
        }
        @media (--mediaMobile) {
          width: calc(400px / var(--scaleMobile));
        }
      }
      & .get-code {
        @media (--mediaPc) {
          width: 100px;
          margin-left: 5px;
          font-size: 14px;
        }
        @media (--mediaMobile) {
          margin-left: calc(10px / var(--scaleMobile));
          width: calc(220px / var(--scaleMobile));
        }
      }
    }
    &.tip {
      color: var(--colorDisabled);
      cursor: pointer;
      @media (--mediaPc) {
        padding-bottom: 30px;
        font-size: var(--textSize5);
      }
      @media (--mediaMobile) {
        padding-bottom: calc(68px / var(--scaleMobile));
        font-size: var(--textSize5Mobile);
      }
      &.signin {
        text-align: right;
        & .link {
          color: var(--color1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/ResetPasswordForm.vue